<template>
  <div>
    <div class="section text-black pt-3 pb-0">
      <i class="bi bi-arrow-left ml-3 goBackArrow" v-on:click="goBack()"></i>
      <div class="container"></div>

      <div class="mt-4" v-if="allLoaded">
        <div class="row text-center mx-0">
          <div class="col-lg-5 col-md-12 px-3 px-lg-5" v-if="allLoaded">
            <div style="height: 100%; text-align: left">
              <h5 class="postcardpercorsi__title orange">
                <b
                  >Dettagli itinerario creato (codice:
                  <template v-if="itineraryCode !== null"
                    >{{ itineraryCode }}
                  </template>
                  <template v-else>Codice non conosciuto</template>
                  )</b
                >
              </h5>

              <div class="mb-3">
                Il tempo totale include anche gli spostamenti da un luogo
                all'altro all'interno della stessa area.
              </div>

              <div v-if="$store.state.sottoitinerari.length > 1">
                Il tempo totale include anche gli spostamenti da un'area
                all'altra.

                <div
                  class="mt-3"
                  v-for="(time, index) in travellingTime"
                  :key="index"
                >
                  {{ time }} <i class="bi bi-clock mr-2"></i>
                </div>
              </div>
              <div
                class="mt-3"
                v-if="Object.keys(totalTimeObject).length === 0 || timeIsZero"
              >
                <h6><i class="bi bi-clock mr-2"></i> Durata non disponibile</h6>
              </div>
              <div v-else class="mt-3">
                <h6
                  class="card-title"
                  v-if="
                    parseInt(totalTimeObject.hours) === 1 &&
                    parseInt(totalTimeObject.minutes) === 0
                  "
                >
                  <i class="bi bi-clock mr-2"></i>
                  {{ totalTimeObject.hours }} ora
                </h6>
                <h6
                  class="card-title"
                  v-else-if="parseInt(totalTimeObject.hours) === 1"
                >
                  <i class="bi bi-clock mr-2"></i>
                  {{ parseInt(totalTimeObject.hours) }} ora e
                  {{ parseInt(totalTimeObject.minutes) }} minuti
                </h6>
                <h6
                  class="card-title"
                  v-else-if="
                    parseInt(totalTimeObject.hours) > 0 &&
                    parseInt(totalTimeObject.minutes) === 0
                  "
                >
                  <i class="bi bi-clock mr-2"></i>
                  {{ parseInt(totalTimeObject.hours) }} ore
                </h6>
                <h6
                  class="card-title"
                  v-else-if="parseInt(totalTimeObject.hours) > 0"
                >
                  <i class="bi bi-clock mr-2"></i>
                  {{ parseInt(totalTimeObject.hours) }} ore e
                  {{ parseInt(totalTimeObject.minutes) }} minuti
                </h6>
                <h6 class="card-title" v-else>
                  <i class="bi bi-clock mr-2"></i>
                  {{ parseInt(totalTimeObject.minutes) }} minuti
                </h6>
              </div>
              <div class="mt-3">
                Da svolgere preferibilmente:
                <b>{{ itinerario.preferredPartOfDay.toUpperCase() }}</b>
              </div>
              <div v-if="itineraryCode !== null" class="row mt-3">
                <div class="col-12">
                  <Button
                    type="primary"
                    size="small"
                    v-on:click="copyItineraryCode()"
                    class="button_font"
                    >Copia codice itinerario
                  </Button>
                </div>
              </div>

              <div class="row mt-3" >
                <div class="col-12">
                  <!--v-if="itineraryCode !== null"-->
                  <Button
                    type="primary"
                    size="small"
                    v-on:click="askQuestion()"
                    class="button_font"
                    >Prenota Itinerario
                  </Button>
                </div>
                <!--<div class="col-12" style="color: indianred" v-else>
                  <h6>Impossibile prenotare l'itinerario per via di problemi con il
                  server</h6>
                </div>-->
              </div>

              <hr />

              <!--TODO definire isLarge-->

              <div class="aree__tagbox mb-4">
                <button
                  :class="
                    selectedArea === index
                      ? 'tag__item__selected'
                      : 'tag__item__unselected'
                  "
                  v-for="(sottoitinerario, index) in $store.state
                    .sottoitinerari"
                  :key="index"
                  v-on:click="selectItinerario(index)"
                >
                  {{ sottoitinerario.name.substring(11) }}
                </button>
              </div>
              <div
                class="col-lg-8 col-sm-12 pr-3 d-sm-block d-lg-none d-md-block mb-4"
              >
                <div class="mb-4">
                  <h6>
                    Tempo sottoitinerario -
                    {{
                      $store.state.sottoitinerari[selectedArea].name.substring(
                        11
                      )
                    }}
                  </h6>
                  <h6
                    class="card-title"
                    v-if="
                      parseInt(totalTimeSelectedArea.hours) === 1 &&
                      parseInt(totalTimeSelectedArea.minutes) === 0
                    "
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ totalTimeSelectedArea.hours }} ora
                  </h6>
                  <h6
                    class="card-title"
                    v-else-if="parseInt(totalTimeSelectedArea.hours) === 1"
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.hours) }} ora e
                    {{ parseInt(totalTimeSelectedArea.minutes) }} minuti
                  </h6>
                  <h6
                    class="card-title"
                    v-else-if="
                      parseInt(totalTimeSelectedArea.hours) > 0 &&
                      parseInt(totalTimeSelectedArea.minutes) === 0
                    "
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.hours) }} ore
                  </h6>
                  <h6
                    class="card-title"
                    v-else-if="parseInt(totalTimeSelectedArea.hours) > 0"
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.hours) }} ore e
                    {{ parseInt(totalTimeSelectedArea.minutes) }} minuti
                  </h6>
                  <h6 class="card-title" v-else>
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.minutes) }} minuti
                  </h6>
                </div>
                <div class="row">
                  <div class="col-12 d-flex px-0">
                    <div
                      class="mb-2 mx-lg-auto mt-0 aree__tagbox"
                      :class="{
                        'w-100': !isLarge,
                      }"
                    >
                      <button
                        :class="
                          selectedTab === 'ElencoAttività'
                            ? 'tag__item__selected'
                            : 'tag__item__unselected'
                        "
                        v-on:click="selectedTab = 'ElencoAttività'"
                      >
                        Elenco delle attività
                      </button>
                      <button
                        :class="
                          selectedTab === 'Mappa'
                            ? 'tag__item__selected'
                            : 'tag__item__unselected'
                        "
                        v-on:click="selectedTab = 'Mappa'"
                      >
                        Mappa
                      </button>
                    </div>
                  </div>

                  <div
                    class="col-12 px-0"
                    v-if="selectedTab === 'ElencoAttività'"
                  >
                    <div v-if="!showDetails" class="mb-4 row">
                      <div class="col-12">
                        <div class="d-sm-block d-md-none">
                          <ElencoPoiSm
                            :itinerario="itinerario"
                            v-on:selectMarkerOnMap="selectMarkerOnMap"
                          ></ElencoPoiSm>
                        </div>
                        <div class="d-sm-none d-md-block col-12">
                          <ElencoPoiMdLg
                            :itinerario="itinerario"
                            v-on:selectMarkerOnMap="selectMarkerOnMap"
                            v-if="isLarge"
                            :screenSize="'medium'"
                          ></ElencoPoiMdLg>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="row mt-2">
                        <div class="col-12">
                          <i
                            class="bi bi-arrow-left ml-3 mb-5"
                            style="
                              font-size: 1.5rem;
                              color: black;
                              cursor: pointer; 
                            "
                            v-on:click="goBackAndResetMarkersIcon()"
                          >
                            Visualizza elenco attività</i
                          >
                          <div class="mt-4 text-center">
                            <esperimento
                              class="align-top text-center"
                              :item="activitySelectedForInfo"
                              v-if="activitySelectedForInfo !== null"
                              :screenSize="'mobile'"
                              :hasCorrectAmbito="true"
                            ></esperimento>
                            <visita
                              class="align-top text-center"
                              :item="activityVisitPOISelectedForInfo"
                              v-if="activityVisitPOISelectedForInfo !== null"
                              :screenSize="'mobile'"
                            ></visita>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 px-0" v-if="selectedTab === 'Mappa'">
                    <l-map
                      style="height: 500px; border-radius: 10px"
                      :zoom="zoom"
                      :center="centerMap"
                      ref="mappaItinerario"
                    >
                      <l-tile-layer
                        :url="url"
                        :attribution="attribution"
                      ></l-tile-layer>
                      <l-marker
                        v-for="(marker, index) in markers"
                        :lat-lng="marker.marker.getLatLng()"
                        :key="'marker' + index"
                      >
                        <l-icon :icon-anchor="dynamicAnchor"
                          v-if="marker.poiSelected"
                          :icon-url="
                            require('../icons/inItineraryWatchedPOI.svg')
                          "
                        ></l-icon>
                        <l-icon :icon-anchor="dynamicAnchor"
                          v-if="!marker.poiSelected"
                          :icon-url="require('../icons/inItineraryPOI.svg')"
                        ></l-icon>
                        <l-popup
                          :options="anchorOptions"
                          style="max-width: 250px"
                        >
                          <div class="px-3">
                            <div class="row">
                              <h5>{{ marker.POItitle }}</h5>
                            </div>
                            <div
                              class="row text-justify fadeeffect"
                              style="max-height: 100px; overflow: scroll"
                            >
                              {{ marker.POIdescription }}
                            </div>
                            <div
                                v-for="(link, index) in marker.links"
                                :key="link['@value']"
                                class="row text-justify fadeeffect"
                                :class="index === 0 ? 'mt-3' : 'mt-1'"
                                style="max-height: 100px; overflow: scroll"
                            >
                              <a :href="getLink(link['@value'])" target="_blank" style="color: #5486a8 !important;">{{getLinkName(link['@value'])}}</a>
                            </div>
                            <div class="row mt-3">
                              <div class="col-12 text-center">
                                <img
                                  v-if="marker.image !== undefined"
                                  v-img="{
                                    group:
                                      getGroupNameMarker(marker) + 'Mobile',
                                  }"
                                  class="margin-auto"
                                  style="border-radius: 5px"
                                  :src="marker.image"
                                  :alt="marker.POItitle"
                                />
                                <img
                                  v-else
                                  v-img="{
                                    group:
                                      getGroupNameMarker(marker) + 'Mobile',
                                  }"
                                  class="postcard__img"
                                  src="@/assets/images/bg3.jpg"
                                  style="border-radius: 5px"
                                  :alt="marker.POItitle"
                                />
                              </div>
                            </div>
                          </div>
                        </l-popup>
                      </l-marker>
                    </l-map>
                  </div>
                </div>
              </div>
              <div class="d-none d-lg-block d-md-none">
                <div class="mb-4">
                  <h6>
                    Tempo sottoitinerario -
                    {{
                      $store.state.sottoitinerari[selectedArea].name.substring(
                        11
                      )
                    }}
                  </h6>
                  <h6
                    class="card-title"
                    v-if="
                      parseInt(totalTimeSelectedArea.hours) === 1 &&
                      parseInt(totalTimeSelectedArea.minutes) === 0
                    "
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ totalTimeSelectedArea.hours }} ora
                  </h6>
                  <h6
                    class="card-title"
                    v-else-if="parseInt(totalTimeSelectedArea.hours) === 1"
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.hours) }} ora e
                    {{ parseInt(totalTimeSelectedArea.minutes) }} minuti
                  </h6>
                  <h6
                    class="card-title"
                    v-else-if="
                      parseInt(totalTimeSelectedArea.hours) > 0 &&
                      parseInt(totalTimeSelectedArea.minutes) === 0
                    "
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.hours) }} ore
                  </h6>
                  <h6
                    class="card-title"
                    v-else-if="parseInt(totalTimeSelectedArea.hours) > 0"
                  >
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.hours) }} ore e
                    {{ parseInt(totalTimeSelectedArea.minutes) }} minuti
                  </h6>
                  <h6 class="card-title" v-else>
                    <i class="bi bi-clock mr-2"></i>
                    {{ parseInt(totalTimeSelectedArea.minutes) }} minuti
                  </h6>
                </div>

                <div v-if="!showDetails" class="mb-4">
                  <div class="col-12">
                    <ElencoPoiMdLg
                      :itinerario="itinerario"
                      v-on:selectMarkerOnMap="selectMarkerOnMap"
                      :screenSize="'large'"
                    ></ElencoPoiMdLg>
                  </div>
                </div>
                <div v-else>
                  <div class="row mt-2">
                    <div class="col-12">
                      <i
                        class="bi bi-arrow-left ml-3"
                        style="font-size: 1.5rem; color: black; cursor: pointer"
                        v-on:click="goBackAndResetMarkersIcon()"
                      >
                        Visualizza elenco attività</i
                      >

                      <div class="mt-4">
                        <esperimento
                          class="align-top text-center"
                          :item="activitySelectedForInfo"
                          v-if="activitySelectedForInfo !== null"
                          :screenSize="'desktop'"
                          :hasCorrectAmbito="true"
                        ></esperimento>
                        <visita
                          class="align-top text-center"
                          :item="activityVisitPOISelectedForInfo"
                          v-if="activityVisitPOISelectedForInfo !== null"
                          :screenSize="'desktop'"
                        ></visita>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-7 col-md-0 col-sm-12 pr-3 d-none d-lg-block">
            <div class="row px-4">
              <div class="col-12">
                <l-map
                  style="height: 800px; border-radius: 10px"
                  :zoom="zoomLarge"
                  :center="centerMap"
                  ref="mappaItinerario"
                >
                  <l-tile-layer
                    :url="url"
                    :attribution="attribution"
                  ></l-tile-layer>
                  <l-marker
                    v-for="(marker, index) in markers"
                    :lat-lng="marker.marker.getLatLng()"
                    :key="'marker' + index"
                  >
                    <l-icon :icon-anchor="dynamicAnchor"
                      v-if="marker.poiSelected"
                      :icon-url="require('../icons/inItineraryWatchedPOI.svg')"
                    ></l-icon>
                    <l-icon :icon-anchor="dynamicAnchor"
                      v-if="!marker.poiSelected"
                      :icon-url="require('../icons/inItineraryPOI.svg')"
                    ></l-icon>
                    <l-popup :options="anchorOptions" style="max-width: 250px">
                      <div class="px-3">
                        <div class="row">
                          <h5>{{ marker.POItitle }}</h5>
                        </div>
                        <div
                          class="row text-justify fadeeffect"
                          style="max-height: 100px; overflow: scroll"
                        >
                          {{ marker.POIdescription }}
                        </div>
                        <div
                            v-for="(link, index) in marker.links"
                            :key="link['@value']"
                            class="row text-justify fadeeffect"
                            :class="index === 0 ? 'mt-3' : 'mt-1'"
                            style="max-height: 100px; overflow: scroll"
                        >
                          <a :href="getLink(link['@value'])" target="_blank"  style="color: #5486a8 !important;">{{getLinkName(link['@value'])}}</a>
                        </div>
                        <div class="row mt-3">
                          <div class="col-12 text-center">
                            <img
                              v-if="marker.image !== undefined"
                              v-img="{ group: getGroupNameMarker(marker) }"
                              class="margin-auto"
                              style="border-radius: 5px"
                              :src="marker.image"
                              :alt="marker.POItitle"
                            />
                            <img
                              v-else
                              v-img="{ group: getGroupNameMarker(marker) }"
                              class="postcard__img"
                              src="@/assets/images/bg3.jpg"
                              style="border-radius: 5px"
                              :alt="marker.POItitle"
                            />
                          </div>
                        </div>
                      </div>
                    </l-popup>
                  </l-marker>
                </l-map>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal
      :show.sync="modals.errorSavingItinerary"
      headerClasses="justify-content-center"
      @close="modals.errorSavingItinerary = false"
    >
      <h4 slot="header" class="title title-up text-center">Errore!</h4>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12 text-center">
              <h6 class="itineraryCode">
                Si è verificato un errore durante il salvataggio dell'itinerario
                sul server. Si prega di contattare l'assistenza.
              </h6>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <Button
          size="small"
          type="danger"
          v-on:click="modals.errorSavingItinerary = false"
          class="mx-1"
          >Chiudi
        </Button>
      </template>
    </modal>

    <modal
      :show.sync="modals.errorUnassignedPresent"
      headerClasses="justify-content-center"
      @close="modals.errorUnassignedPresent = false"
    >
      <h4 slot="header" class="title title-up text-center">Attenzione!</h4>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12 text-center">
              <h6 class="itineraryCode mb-4">
                Le seguenti attività non sono state inserite nell'itinerario per
                motivi di tempo.
              </h6>
              <div
                v-for="(notAssigned, index) in this.visualUnassigned"
                :key="index"
              >
                <div class="row">
                  <div class="col-12 col-lg-6 text-center">
                    {{ notAssigned.areaName }}
                  </div>

                  <div class="col-12 col-lg-4 text-center">
                    {{ notAssigned.activityName }}
                  </div>
                  <div class="col-12 col-lg-2 text-center">
                    {{ notAssigned.durata }} minuti
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <Button
          size="small"
          type="danger"
          v-on:click="modals.errorUnassignedPresent = false"
          class="mx-1"
          >Chiudi
        </Button>
      </template>
    </modal>

    <modal
      :show.sync="modals.askQuestionModal"
      headerClasses="justify-content-center"
      @close="modals.askQuestionModal = false"
    >
      <h4 slot="header" class="title title-up text-center">
        VALUTA LA TUA ESPERIENZA NEL CREARE L’ITINERARIO
      </h4>
      <div class="row">
        <div class="col-12">
          <div
            class="row mb-4"
            v-for="(question, index) in questions"
            :key="'question' + index"
          >
            <div class="col-12 text-center px-0">
              <div class="row">
                <div class="col-12 text-center">
                  <b class="itineraryCode">{{ question.question }}</b>
                  <h6 class="responseError" v-if="question.responseError">
                    Inserisci un valore per questa risposta
                  </h6>
                </div>
              </div>
              <div
                class="mx-auto row"
                :class="question.responseError ? 'responseError' : 'responseOk'"
              >
                <n-radio
                  v-for="response in question.response"
                  :key="response"
                  v-model="question.selectedResponse"
                  :label="response"
                  class="mx-auto"
                  @input="question.responseError = false"
                >
                  {{ response }}
                </n-radio>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <Button
          size="small"
          type="danger"
          v-on:click="modals.askQuestionModal = false"
          class="mx-1"
          >Chiudi
        </Button>
        <Button
          size="small"
          type="primary"
          v-on:click="bookItinerary()"
          class="mx-1"
          >Prenota Itinerario
        </Button>
      </template>
    </modal>

    <modal
      :show.sync="modals.errorSavingValutation"
      headerClasses="justify-content-center"
      @close="modals.errorSavingValutation = false"
    >
      <h4 slot="header" class="title title-up text-center">Errore!</h4>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12 text-center">
              <h6 class="itineraryCode">
                Si è verificato un errore durante il salvataggio delle risposte
                alla valutazione sul server. Si prega di contattare
                l'assistenza.
              </h6>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <Button
          size="small"
          type="danger"
          v-on:click="modals.errorSavingValutation = false"
          class="mx-1"
          >Chiudi
        </Button>
      </template>
    </modal>

    <modal
      :show.sync="modals.thanksForValutation"
      headerClasses="justify-content-center"
      @close="modals.thanksForValutation = false"
    >
      <h4 slot="header" class="title title-up text-center">
        Grazie per la tua valutazione!
      </h4>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12 text-center">
              <h6 class="itineraryCode">
                Ti ringraziamo per averci fornito il tuo feedback.
              </h6>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <Button
          size="small"
          type="danger"
          v-on:click="modals.thanksForValutation = false"
          class="mx-1"
          >Chiudi
        </Button>
      </template>
    </modal>

    <ScrollTopArrow :createItinerary="false"></ScrollTopArrow>
  </div>
</template>
<script>
import store from "../store";
import $ from "jquery";
import { Button } from "element-ui";
import router from "../router";
import esperimento from "../components/customComponents/esperimento";
import visita from "../components/customComponents/visita";
import { isMobile } from "mobile-device-detect";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import Vue from "vue";
import { Radio, Modal } from "../components";
import { config } from "../utils/config";
import ScrollTopArrow from "../components/customComponents/ScrollTopArrow";
import ElencoPoiMdLg from "../components/customComponents/itinerarioCreato/ElencoPoiMdLg";
import ElencoPoiSm from "../components/customComponents/itinerarioCreato/ElencoPoiSm";

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
});

import { LMap, LMarker, LPopup, LIcon, LTileLayer } from "vue2-leaflet";

const Common = require("@/Common.vue").default;

export default {
  name: "sintesiitinerario",
  bodyClass: "strumenti-esperimenti-page",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    Button,
    Modal,
    esperimento,
    visita,
    [Radio.name]: Radio,
    ScrollTopArrow,
    ElencoPoiMdLg,
    ElencoPoiSm,
  },
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 16,
      zoomLarge: 14,
      center: [45.47724690648075, 7.888264286334166],
      map: null,
      geojson: null,
      markers: [],
      markersPolylines: [],
      anchorOptions: { offset: L.point(-6.5, -37) },
      showDetails: false,
      selectedTab: "ElencoAttività",
      selectedArea: 0,
      allLoaded: false,
      itineraryCode: null,
      totalTimeObject: {},
      totalTimeSelectedArea: {},
      itinerario: null,
      isMobile: false,
      travellingTime: [],
      windowWidth: 0,
      unassigned: [],
      visualUnassigned: [],

      modals: {
        errorSavingItinerary: false,
        errorUnassignedPresent: false,
        askQuestionModal: false,
        errorSavingValutation: false,
        thanksForValutation: false,
      },

      areasIndexes: {
        Torino: 0,
        Ivrea: 1,
        "GeoDidaLab - Ivrea": 2,
        "Anfiteatro Morenico d'Ivrea": 3,
      },

      questions: [
        {
          question:
            "Quanto l’applicazione che hai usato ti è stata utile nel supportarti come docente nell’organizzazione di una gita scolastica tipo esperienziale?",
          response: ["1", "2", "3", "4", "5"],
          selectedResponse: "",
          responseError: false,
        },
        {
          question:
            "L’applicazione riesce a motivarti nell’organizzare il viaggio d’istruzione?",
          response: ["1", "2", "3", "4", "5"],
          selectedResponse: "",
          responseError: false,
        },
        {
          question: "Quanto è stato facile organizzare l’itinerario?",
          response: ["1", "2", "3", "4", "5"],
          selectedResponse: "",
          responseError: false,
        },
        {
          question:
            "Pensi che sapere quanto tempo ti rimane a disposizione sia utile nel pianificare la gita e le attività?",
          response: ["1", "2", "3", "4", "5"],
          selectedResponse: "",
          responseError: false,
        },
      ],
    };
  },

  beforeCreate() {
    if (!config.isGeodidalab) {
      router.replace({
        name: "index",
      });
    }
  },

  mounted() {
    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });

    this.isMobile = isMobile;

    var itinerarioVROOM = JSON.parse(sessionStorage.getItem("itinerarioVROOM")); //contiene i vari sottoitinerari
    store.state.sottoitinerari = itinerarioVROOM;

    if (
      store.state.sottoitinerari !== undefined &&
      store.state.sottoitinerari !== null &&
      store.state.sottoitinerari.length > 0
    ) {
      Array.prototype.forEach.call(
        store.state.sottoitinerari,
        (sottoitinerario) => {
          if (sottoitinerario.unassignedArray.length > 0) {
            this.unassigned.push(sottoitinerario.unassignedArray);
          }

          //inoltre imposto la parte della giornata a quella di default se non è presente
          if (
            sottoitinerario.preferredPartOfDay === null ||
            sottoitinerario.preferredPartOfDay === undefined
          ) {
            sottoitinerario.preferredPartOfDay =
              config.omekaIDs.defaultPreferredPartOfDay;
          }
        }
      );

      this.unassigned = [].concat.apply([], this.unassigned);

      Array.prototype.forEach.call(this.unassigned, (unassigned) => {
        var splittedDescription = unassigned.description.split("_");
        var obj = {
          areaName: splittedDescription[0],
          activityName: splittedDescription[1],
          durata: unassigned.service / 60000,
        };

        this.visualUnassigned.push(obj);
      });

      if (this.unassigned.length > 0) {
        this.modals.errorUnassignedPresent = true;
      }

      this.setTravellingTime();

      this.getDescriptionAndMediaOfPOI();

      this.totalTimeObject = this.msToTime(this.totalTime);

      this.itinerario = store.state.sottoitinerari[0];

      this.totalTimeSelectedArea = this.msToTime(
        this.itinerario.totalTimeMilliseconds
      );

      this.createMarkerArray();
      this.initializeMarkersOfFilteredPOI();

      var itineraryAlreadyExist = this.$route.params.itineraryAlreadyExist;

      if (!itineraryAlreadyExist) {
        //se la pagina  è ricaricata l'itinerario non deve essere ricaricato!!

        /*
        if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
          console.info("This page is reloaded");
          this.itineraryCode = store.state.itineraryCode;
        } else {
          console.info("This page is not reloaded");
          this.saveItinerary();
        }
        */

        this.saveItinerary(itinerarioVROOM);
      } else {
        this.itineraryCode = this.$route.params.itineraryCode;
      }

      this.allLoaded = true;
      var path = this.$store.state.sottoitinerari.map((item) =>
        item.name.replace("Itinerario_", "")
      );
    } else {
      //se l'utente carica l'url per la sinstesi dell'itinerario senza aver messo il codice viene mandato alla pagina dei percorsi
      router.push({ path: "/percorsi", replace: true });
    }
  },

  created() {},

  methods: {
    goBack() {
      router.go(-1);
    },

    getGroupName(poi) {
      return poi.poiName.replaceAll('"', "");
    },

    getGroupNameMarker(marker) {
      return marker.POItitle.replaceAll('"', "");
    },

    getDescriptionAndMediaOfPOI() {
      Array.prototype.forEach.call(
        store.state.sottoitinerari,
        (sottoitinerario) => {
          Array.prototype.forEach.call(sottoitinerario.poi, (poi) => {
            var filteredPOI = store.state.POIpivot.filter(
              (p) => p["geo:Titolo_it"][0]["@value"] === poi.poiName
            );

            //se non vale questa condizione allora si tratta del Punto di Partenza o del Punto di Arrivo e quindi non sono presenti nei POi pivot
            if (filteredPOI.length > 0) {
              poi.poiDescription = filteredPOI[0]["dcterms:description"]
                ? filteredPOI[0]["dcterms:description"][0]["@value"]
                : "Nessuna descrizione disponibile";
              poi.media = filteredPOI[0]["media"];
              poi.poiID = filteredPOI[0]["o:id"];
              poi["geo:Scheda_esterna"] = filteredPOI[0]["geo:Scheda_esterna"];
            }
          });
        }
      );
    },

    getCount(i, j) {
      var k = 0;
      var l = 0;
      for (var x = 1; x <= i; x++) {
        for (
          var h = 0;
          h < this.itinerario.poi[x].activitiesInPOI.length;
          h++
        ) {
          if (x === i) {
            if (l < j) {
              l += 1;
            }
          } else {
            k += 1;
          }
        }
      }

      k += l;

      return k + 1;
    },

    selectMarkerOnMap(poiName, activityName) {
      this.showDetails = true;
      Array.prototype.forEach.call(this.markers, (marker) => {
        if (marker.POItitle === poiName) {
          marker.poiSelected = true;
        } else {
          marker.poiSelected = false;
        }
      });

      this.showInfoAtivity(poiName, activityName);
    },

    showInfoAtivity(poiName, activityName) {
      var selectedPOI = null;
      Array.prototype.forEach.call(store.state.POIpivot, (poi) => {
        if (poiName === poi["geo:Titolo_it"][0]["@value"]) {
          selectedPOI = poi;

          //il component per la visualizzazione delle visite usa mediaImages
          if (selectedPOI.mediaImages === undefined) {
            selectedPOI.mediaImages = selectedPOI.media;
          }
        }
      });

      if (!activityName.includes("Visita")) {
        this.activityVisitPOISelectedForInfo = null;

        Array.prototype.forEach.call(store.state.esperimenti, (activity) => {
          if (activity["o:title"] === activityName) {
            this.activitySelectedForInfo = activity;
          }
        });

        this.activityVisitPOISelectedForInfo = null;
      } else {
        this.activityVisitPOISelectedForInfo = selectedPOI;

        this.activitySelectedForInfo = null;
      }
    },

    selectItinerario(index) {
      this.itinerario = store.state.sottoitinerari[index];
      this.totalTimeSelectedArea = this.msToTime(
        this.itinerario.totalTimeMilliseconds
      );

      this.selectedArea = index;

      this.createMarkerArray();
      this.initializeMarkersOfFilteredPOI();
    },
    goBackAndResetMarkersIcon() {
      this.showDetails = false;
      Array.prototype.forEach.call(this.markers, (marker) => {
        marker.poiSelected = false;
      });
    },
    copyItineraryCode() {
      // navigator clipboard api needs a secure context (https)
      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard api method'
        navigator.clipboard.writeText(String(this.itineraryCode));
      } else {
        // text area method
        let textArea = document.createElement("textarea");
        textArea.value = String(this.itineraryCode);
        // make the textarea out of viewport
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        new Promise((res, rej) => {
          // here the magic happens
          document.execCommand("copy") ? res() : rej();
          textArea.remove();
        });
      }

      this.$toast("Codice itinerario copiato negli appunti!", {
        position: "top-right",
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false,
      });
    },
    bookItinerary() {
      var self = this;

      var errorIsPresent = false;

      // stampo le risposte inserite per la valutazione
      Array.prototype.forEach.call(this.questions, (question) => {
        if (question.selectedResponse === "") {
          question.responseError = true;
          errorIsPresent = true;
        }
      });

      if (!errorIsPresent) {
        this.modals.askQuestionModal = false;

        this.saveValutationOnDB();

        // apro il client mail
        this.sendEmail();
      }
    },
    saveValutationOnDB() {
      //TODO: IMPLEMENTARE SALVATAGGIO RISPOSTE SUL DB

      /*
      Tabella con i seguenti campi: ID (automatico), codice itinerario, domanda, risposta, FORSE HA SENSO IL CAMPO "itinerario creato / predefinitio"
      */

      var strToSend = "";

      Array.prototype.forEach.call(this.questions, (question) => {
        strToSend +=
          this.itineraryCode +
          ";" +
          question.question +
          ";" +
          question.selectedResponse +
          ";" +
          true.toString() +
          "\n";
      });

      var self = this;

      $.ajax({
        url: "/geodidalab/api/itinerari/valutazioni",
        type: "POST",
        contentType: "application/json",
        data: strToSend,
        success: function (result) {
          self.modals.thanksForValutation = true;
        },
        error: function (error) {
          self.modals.errorSavingValutation = true;
        },
      });
    },

    saveItinerary(itinerarioVROOM) {
      var self = this;

      $.ajax({
        url: "/geodidalab/api/itinerari/",
        type: "POST",
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify(itinerarioVROOM),
        success: function (result) {
          self.itineraryCode = result;
          store.state.itineraryCode = result;
        },
        error: function (error) {
          self.modals.errorSavingItinerary = true;
        },
      });
    },

    createMarkerArray() {
      //Punto di partenza
      //this.markersPolylines.push(this.startPoint);
      Array.prototype.forEach.call(this.itinerario.poi, (poi) => {
        if (poi["location"]) {
          var POIlat = poi["location"][0];
          var POIlng = poi["location"][1];

          var POIcoordinates = [POIlat, POIlng];

          this.markersPolylines.push(POIcoordinates);
        }
      });

      //Punto di arrivo
      //this.markersPolylines.push(this.endPoint);
    },

    initializeMarkersOfFilteredPOI() {
      this.markers = [];

      Array.prototype.forEach.call(this.itinerario.poi, (poi) => {
        //viene usato anche per il punto di arrivo
        var isStartingPoint =
          poi["poiName"] === "Punto di partenza" ||
          poi["poiName"] === "Punto di arrivo";

        if (isStartingPoint) {
          // this.markers.push({
          //   marker: L.marker([poi["location"][0], poi["location"][1]]),
          //   color: "#1585bd",
          //   strokeColor: "#1b4f88",
          //   circleColor: "#ffffff",
          //   POItitle: poi["poiName"],
          //   POIdescription: poi["poiDescription"],
          //   image: poi["media"]
          //     ? poi["media"][0]["o:thumbnail_urls"]["large"]
          //     : undefined,
          //   //TODo: aggiungere attributi
          //   isStartPoint: isStartingPoint,
          //   poiSelected: false,
          // });
        } else {
          //console.log("POI");
          //console.log(poi);
          if (poi["location"]) {
            this.markers.push({
              marker: L.marker([poi["location"][1], poi["location"][0]]),
              color: "#1585bd",
              strokeColor: "#1b4f88",
              circleColor: "#ffffff",
              POItitle: poi["poiName"],
              POIdescription: poi["poiDescription"],
              image: poi["media"][0]
                ? poi["media"][0]["o:thumbnail_urls"]["large"]
                : undefined,
              links: poi['geo:Scheda_esterna'],
              //TODo: aggiungere attributi
              isStartPoint: isStartingPoint,
              poiSelected: false,
            });
          }
        }
      });

      this.markersCreated = true;
    },

    askQuestion() {
      this.modals.askQuestionModal = true;
    },

    sendEmail() {
      var emailAddress = "info@geodidalab.it";
      var subject = "Richiesta informazioni itineraio " + this.itineraryCode;
      var preferredPartOfDay =
        this.$store.state.preferredPartOfDay === "mattina"
          ? "preferibilmente al mattino"
          : this.$store.state.preferredPartOfDay === "pomeriggio" ? "preferibilmente al " + this.$store.state.preferredPartOfDay : this.$store.state.preferredPartOfDay === "indifferente" ? "quando possibile" : "preferibilmente nella fascia oraria " + this.$store.state.customTimeSlot;

      var body =
        "Gentile GeoDidaLab,%0D%0A siamo interessati alla realizzazione dell'itinerario nell'oggetto, da svolgersi " +
        preferredPartOfDay +
        '.%0D%0A Attendiamo un gentile riscontro. %0D%0A %0D%0A ------------------------------------------------ %0D%0A %0D%0A Per rivedere in futuro l\'itinerario creato è necessario collegarsi al link https://openalplab.unito.it/geodidalab#/percorsi, andare nella sezione "Inserisci il codice del tuo itinerario" e inserire il codice ' +
        this.itineraryCode +
        ".";

      var mail = document.createElement("a");
      mail.href =
        "mailto:" + emailAddress + "?subject=" + subject + "&body=" + body;
      mail.click();
    },

    msToTime(duration) {
      var milliseconds = Math.floor((duration % 1000) / 100),
        seconds = Math.floor((duration / 1000) % 60),
        minutes = Math.floor((duration / (1000 * 60)) % 60),
        hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      var timeObject = {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        milliseconds: milliseconds,
      };

      if (isNaN(duration)) {
        timeObject = {
          hours: null,
          minutes: null,
          seconds: null,
          milliseconds: null,
        };
      }

      return timeObject;
    },

    setTravellingTime() {
      var areas = [];

      //Recupero le aree a cui appartengono i sottoitinerari
      Array.prototype.forEach.call(
        this.$store.state.sottoitinerari,
        (sottoitinerario) => {
          var areaID = sottoitinerario.areaID;
          areas.push(areaID);
        }
      );

      //Sommo i tempi di tragitto da un'area all'altra

      for (var i = 0; i < this.$store.state.sottoitinerari.length - 1; i++) {
        var string = "";

        var distancesFromAreaOfIndexI =
          this.$store.state.costMatricesTimeBetweenAreas.filter(
            (area) =>
              parseInt(area.AreaID) ===
              this.$store.state.sottoitinerari[i].areaID
          );
        var distancesFromAreaOfIndexIPlus1 =
          this.$store.state.costMatricesTimeBetweenAreas.filter(
            (area) =>
              parseInt(area.AreaID) ===
              this.$store.state.sottoitinerari[i + 1].areaID
          );

        var destinationAreaString = String(
          this.$store.state.sottoitinerari[i + 1].areaID
        );

        var areaNameIndexI = distancesFromAreaOfIndexI[0]
          ? distancesFromAreaOfIndexI[0].AreaName
          : this.$store.state.sottoitinerari[i].areaName;
        var areaNameIndexIPlus1 = distancesFromAreaOfIndexIPlus1[0]
          ? distancesFromAreaOfIndexIPlus1[0].AreaName
          : this.$store.state.sottoitinerari[i + 1].areaName;
        var timeBetweenAreas =
          distancesFromAreaOfIndexI[0] &&
          distancesFromAreaOfIndexI[0][destinationAreaString]
            ? distancesFromAreaOfIndexI[0][destinationAreaString]
            : config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;

        string =
          "Tempo di spostamento in auto da " +
          areaNameIndexI +
          " a " +
          areaNameIndexIPlus1 +
          ": " +
          timeBetweenAreas / 60000 + // converto i millisecondi in minuti
          " minuti \n";

        this.travellingTime.push(string);
      }
    },

    checkPoiAndNextPoiAreDifferent(poi, nextPOI) {
      return poi.poiID !== nextPOI.poiID;
    },

    getTimeToNextPOI(poi, nextPOI) {
      var timesFromPOI = store.state.costMatricesTimeBetweenPOI.filter(
        (p) => parseInt(p["PoiID"]) === poi.poiID
      );

      var timeMillis = config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000; //minuti di default di spostamento tra un poi e l'altro

      if (timesFromPOI[0]) {
        timeMillis = timesFromPOI[0][nextPOI.poiID];
      }

      if (timeMillis === "-1") {
        //se il tempo è -1 vuol dire che non è stato possibile calcolare il tempo di spostamento tra i due POI e usiamo quello di default
        timeMillis = config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;
      }

      var timeMinutes = timeMillis / 60000;

      if (timeMinutes === 1) {
        return timeMinutes + " minuto";
      } else {
        return timeMinutes + " minuti";
      }
    },
    getLink(link){
      if(link.split('~').length > 1) {
        var split = link.split('~');
        return split[1];
      } else {
        return link;
      }
    },
    getLinkName(link){
      if(link.split('~').length > 1) {
        var split = link.split('~');
        return split[0];
      } else {
        return "Dettagli";
      }
    }
  },

  computed: {
    dynamicAnchor () {
      return [20, 64 * 0.65];
    },
    
    isLarge() {
      return this.windowWidth >= 768;
    },

    timeIsZero() {
      return (
        (this.totalTimeObject.hours === "00" &&
          this.totalTimeObject.minutes === "00" &&
          this.totalTimeObject.seconds === "00" &&
          this.totalTimeObject.milliseconds === 0) ||
        (this.totalTimeObject.hours === null &&
          this.totalTimeObject.minutes === null &&
          this.totalTimeObject.seconds === null &&
          this.totalTimeObject.milliseconds === null)
      );
    },

    centerMap() {
      var sumLat = 0;
      var sumLng = 0;

      Array.prototype.forEach.call(this.markers, (marker) => {
        sumLat += marker.marker["_latlng"].lat;
        sumLng += marker.marker["_latlng"].lng;
      });

      var middleLat = sumLat / this.markers.length;
      var middleLng = sumLng / this.markers.length;

      if (isNaN(middleLat) || isNaN(middleLng)) {
        return [45.47724690648075, 7.888264286334166];
      } else {
        return [middleLat, middleLng];
      }
    },

    totalTime() {
      var areas = [];
      var time = 0;

      //Recupero le aree a cui appartengono i sottoitinerari
      Array.prototype.forEach.call(
        this.$store.state.sottoitinerari,
        (sottoitinerario) => {
          var areaID = sottoitinerario.areaID;
          areas.push(areaID);
        }
      );

      //Sommo i tempi relativi ai sottoitinerari
      Array.prototype.forEach.call(
        this.$store.state.sottoitinerari,
        (sottoitinerario) => {
          time += sottoitinerario.totalTimeMilliseconds;
        }
      );

      //Sommo i tempi di tragitto da un'area all'altra
      for (var i = 0; i < areas.length - 1; i++) {
        var distancesFromAreaOfIndexI =
          this.$store.state.costMatricesTimeBetweenAreas.filter(
            (area) => parseInt(area.AreaID) === areas[i]
          );
        var destinationAreaString = String(areas[i + 1]);

        if (
          distancesFromAreaOfIndexI.length === 0 ||
          distancesFromAreaOfIndexI[0][destinationAreaString] === undefined
        ) {
          //SOMMO I MINUTI DI DEFAULT DI SPOSTAMENTO TRA LE AREE
          time += config.omekaIDs.defaultTravelTimeBetweenAreas * 60000;
        } else {
          time += distancesFromAreaOfIndexI[0][destinationAreaString];
        }
      }

      return time;
    },
  },

  watch: {},
};
</script>
<style>

</style>
